import { TrialEmail } from "@pages/trial/trial-email";
import { TrialServer } from "@pages/trial/trial-server";
import { useState } from "react";
import { Box } from "@mui-wrapper";
import { TrialProps } from "@pages/trial/trial-types";
import { RegisterableServer } from "@custom-types/server-types";
import { SignupLoginLink } from "@components/signup/signup-login-link";

interface Props extends Pick<TrialProps, "setFormData" | "setStep"> {
  /** Email address */
  email?: string;
}

/**
 * Renders the first step of the trial registration flow.
 * It first let's the user select the server region.
 * It then allows the user to enter their email address. The email address
 * will be verified to ensure it is valid and that the email address is
 * eligible for a trial registration.
 */
export function TrialStepOne({
  setFormData,
  setStep,
  email,
}: Props): JSX.Element {
  const [isInCorrectRegion, setIsInCorrectRegion] = useState<boolean>(false);

  function setEmailAndServer(email: string, server: RegisterableServer): void {
    setFormData((prev) => ({
      ...prev,
      email,
      server,
    }));

    setStep("two");
  }

  return (
    <Box
      data-testid="trial-step-one"
      sx={{
        width: "100%",
      }}
    >
      <SignupLoginLink />
      <TrialServer setIsInCorrectServer={setIsInCorrectRegion} />
      <TrialEmail
        email={email}
        setEmailAndServer={setEmailAndServer}
        isDisabled={!isInCorrectRegion}
      />
    </Box>
  );
}
